import "src/decidim/decidim-anonymous_proposals/form_autosave";
require.context("../images", true);
